import React, {useState} from 'react';
import DatePicker from "react-datepicker";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";

const dateFormat = 'yyyy-MM-DD';

export default function DetailFormDatePicker({ onChange, label, value, error, required, type }) {
    const [startDate, setStartDate] = useState(value || null); // Initialize with passed value

    return (
        <div className="w-full relative flex justify-center items-center bg-white flex-row">
            <div className="w-full relative">
                <DatePicker
                    selected={startDate} // Use startDate for the selected date
                    onChange={(date) => {
                        setStartDate(date); // Update local state
                        onChange(date); // Pass the date back to parent
                    }}
                    customInput={
                        <div>
                            <input
                                type={type}
                                name={label}
                                id={label}
                                value={startDate ? moment(startDate).format(dateFormat).toString() : ''}
                                className={`border border-gray-200 px-2 py-1 rounded w-full`}
                                autoComplete="off"
                                onChange={onChange}
                            />
                        </div>
                    }
                />
                <div className={`flex flex-row items-center mt-1 ${error ? "" : "hidden"}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="rgba(239, 68, 68, 1)"
                        className="w-5 h-5"
                    >
                        <path
                            fillRule="evenodd"
                            d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                            clipRule="evenodd"
                        />
                    </svg>
                    <p className="ml-1 text-red-500 text-xs overflow-visible">{error}</p>
                </div>
            </div>
        </div>
    );
}
